export default __webpack_public_path__ + "img/chardonnay.asset.92c81f5b.png";